import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { serviceURLService } from '../../service/serviceURL';

@Component({
    selector: 'app-statistics',
    templateUrl: './statistics.component.html',
    styleUrls: ['./statistics.component.css']
})
export class StatisticsComponent implements OnInit {

    roleData: any = {};
    responseData:any;
    agentResponseData:any;
    agentList:any[];
    showAgentList:boolean=false;
    showStats:boolean=true;
    showAgentStats:boolean=false;
    agentDetails:any;

    constructor(private router: Router, private location: Location, private serviceURLService: serviceURLService) {
        this.roleData = JSON.parse(localStorage.getItem('role_pam'));
    }

    ngOnInit() {
    this.getAgentStaticsData();
    this.getAgentList();
    }
    getAgentStaticsData(){
      this.serviceURLService.getStaticsData(this.roleData.pamUserID).subscribe((successData: any) => {
      this.responseData=successData.data;
    }, errorData => {
      if (errorData.error.status === 401) {
        this.router.navigate(['/login']);
        console.log("Please login first");
      } 
    })
    }
    getAgentList(){
      this.serviceURLService.getAgentList(this.roleData.pamUserID).subscribe((successData: any) => {
        console.log("agent list::  ");
      this.agentList=successData.data.data;
      console.log("agent list::  "+this.agentList.length);
    }, errorData => {
      console.log("agent error::  ");
      if (errorData.error.status === 401) {
        this.router.navigate(['/login']);
        console.log("Please login first");
      } 
    })
    }

    agentStaticsData(agent){
      this.agentDetails=agent;
      this.showAgentStats=true;
      this.showAgentList=false;
      console.log("agent id++ "+this.agentDetails.id);
      this.serviceURLService.getStaticsData(this.agentDetails.id).subscribe((successData: any) => {
      this.agentResponseData=successData.data;
    }, errorData => {
      if (errorData.error.status === 401) {
        this.router.navigate(['/login']);
        console.log("Please login first");
      } 
    })
    }

    openAgentView(){
      this.showAgentList=true;
      this.showStats=false;
    }
    closeAgentView(){
      this.showAgentList=false;
      this.showStats=true;
    }
    backToAgentlist(){
      this.showAgentStats=false;
      this.showAgentList=true;
    }

}